import cardanoTokensConfig from '@/data/lists/cardano.tokenlist.json';
import { CardanoToken } from './models/cardano-token';
import { DEFAULT_CARDANO_CHAIN_ID } from '@/constants/DEFAULT_CARDANO_ID';

export function loadCardanoTokens(): CardanoToken[] {
  return cardanoTokensConfig.tokens.filter(
    token => String(token.chainId) === DEFAULT_CARDANO_CHAIN_ID,
  );
}
